/* eslint-disable react/no-unknown-property */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CloseIcon from '../icons/CloseIcon';
import {
  setShowRegistration, memberRegistration, login, setHasRegistered, setLoggedUser, setShowLogin,
  setShowRecoverPassword, checkRegistrationEmail, resendActivationLink,
} from '../../actions/Loyalty';

import '../../static/less/loyalty.less';
import '../../static/images/loading5.gif';
import {
  DEVICES, sendGTMEvents, getCountries, setClientIpCountryCode,
} from '../../actions/Booking';
import Checkbox from '../common/Checkbox';
import '../../static/less/new_shopping_cart/userRegistration2.css';
import sandos4uWhite from '../../static/images/sandos4uWhite.png';
import DsDropdownList from '../ds/molecules/DropdownList';
import FormControl from '../common/FormControl';
import { getLangValue } from '../../utils/Generic';
import IntlTelInput from '../common/IntlTelInput';
import LoyaltyEmailStatusHelp, { getEmailInputStatusClass } from './LoyaltyEmailStatusHelp';
import LoyaltyActivationLinkSentModal from './LoyaltyActivationLinkSentModal';
import {
  EMAIL_FORM, EmailStatusChecker, canResendActivationLink, getInitialEmailCheckState,
  isEmailFormatValid, isEmailStatusSettled, isSubmitBlockedByEmailStatus, RESEND_ERROR_THROTTLED,
  setForgotPasswordPrefillEmail,
} from '../../utils/loyaltyEmailStatus';

const sortByAlphabet = (a, b) => a.name.localeCompare(b.name);
const countryMapper = (country, lang) =>
  ({ ...country, name: getLangValue(country, lang, 'name') });

class UserRegistration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: {
        name: 'name', value: '', valid: undefined, msg: '', required: true,
      },
      middle_name: {
        name: 'middle_name', value: '', valid: undefined, msg: '', required: false,
      },
      last_name: {
        name: 'last_name', value: '', valid: undefined, msg: '', required: true,
      },
      second_last_name: {
        name: 'second_last_name', value: '', valid: undefined, msg: '', required: false,
      },
      cli_country: {
        name: 'cli_country',
        value: {
          code: '',
          name: '',
        },
        valid: undefined,
        msg: '',
        required: true,
      },
      cli_phone: {
        name: 'cli_phone', value: '', valid: undefined, msg: '', required: true,
      },
      date_of_birth: {
        name: 'date_of_birth', value: '', valid: undefined, msg: '', required: true,
      },
      countries: { options: [], lang: props.lang },
      email: {
        name: 'email', value: '', valid: undefined, msg: '', required: true,
      },
      email2: {
        name: 'email2', value: '', valid: undefined, msg: '', required: false,
      },
      password: {
        name: 'password', value: '', valid: undefined, msg: '', required: true,
      },
      password2: {
        name: 'password2', value: '', valid: undefined, msg: '', required: true,
      },
      loading: false,
      registrationErrorMessage: null,
      passwordShown: false,
      book_conditions: {
        value: false,
        valid: false,
        msg: '',
        required: true,
      },
      book_optin: {
        value: false,
        valid: false,
        msg: '',
        required: false,
      },
      // Pre-check del email en loyalty (checkRegistrationEmail)
      ...getInitialEmailCheckState(),
    };

    this.emailChecker = new EmailStatusChecker({
      check: (email) => this.props.checkRegistrationEmail(email),
      onUpdate: (update) => this.setState(update),
    });
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillUpdate(nextProps) {
    if (nextProps.lang !== this.props.lang) {
      this.buildIntlCountryOptions(
        this.state.countries.options,
        nextProps.lang,
      );
    }
  }

  async componentDidMount() {
    await this.getCountries();
  }

  componentWillUnmount() {
    this.emailChecker.dispose();
  }

  async getCountries() {
    const countries = await this.props.getCountries();
    if (countries) {
      let allCountries = [];
      if (countries && countries.commons && countries.commons.length > 0) {
        allCountries = countries.commons.concat(countries.not_commons);
        /*this.setState({
          cli_country: { ...this.state.cli_country, value: countries.client_ip_country_code },
          cli_phone: { ...this.state.cli_phone, value: `+${countries.client_ip_country_code.dial_code}` },
        });*/
      }
      this.buildIntlCountryOptions(allCountries, this.props.lang);
    }
  }

  buildIntlCountryOptions(countryList, lang) {
    let language = lang;
    if (!language) {
      language = this.props.lang;
    }
    const mappedCountries = countryList
      .map((country) => countryMapper(country, language))
      .sort(sortByAlphabet);
    this.setState({ countries: { options: mappedCountries, lang: language } });
  }

  isFormValid = () => {
    const newState = { ...this.state };
    let isValid = true;

    newState.email.valid = undefined;
    newState.email.msg = '';
    newState.email2.valid = undefined;
    newState.email2.msg = '';
    newState.cli_phone.valid = undefined;
    newState.cli_phone.msg = '';
    newState.password.valid = undefined;
    newState.password.msg = '';
    newState.password2.valid = undefined;
    newState.password2.msg = '';
    newState.book_conditions.valid = false;
    newState.book_conditions.msg = '';
    newState.book_optin.valid = false;
    newState.book_optin.msg = '';

    if (this.state.password.value !== this.state.password2.value) {
      newState.password.valid = false;
      newState.password.msg = this.context.t('Both passwords does not mismatch');
      isValid = false;
    }

    if (!this.state.book_conditions.value) {
      newState.book_conditions.valid = false;
      newState.book_conditions.msg = this.context.t('Please accept Terms and Conditions');
      isValid = false;
    }

    this.setState(newState);

    return isValid;
  };

  // Regresa el status del email actual; si aún no lo tenemos, lo consulta en ese momento
  ensureEmailStatus = async () => {
    const email = this.state.email.value;
    if (!isEmailFormatValid(email)) {
      return null;
    }
    if (isEmailStatusSettled(this.state, email)) {
      return this.state.emailStatus;
    }
    const status = await this.emailChecker.checkNow(email);
    return status === undefined ? null : status;
  };

  register = async (event) => {
    event.preventDefault();
    if (this.state.loading || !this.isFormValid()) {
      return;
    }
    this.setState({ loading: true });
    const emailStatus = await this.ensureEmailStatus();
    if (isSubmitBlockedByEmailStatus(EMAIL_FORM.REGISTER, emailStatus)) {
      // El mensaje con el motivo ya se muestra debajo del input de email
      this.setState({ loading: false });
      return;
    }
    const payload = {
      name: this.state.name.value,
      middle_name: this.state.middle_name.value,
      last_name: this.state.last_name.value,
      second_last_name: this.state.second_last_name.value,
      email: this.state.email.value,
      password: this.state.password.value,
      optin_accepted: this.state.book_optin.value,
      country_code: this.state.cli_country.value.code,
      date_of_birth: this.state.date_of_birth.value,
      telephone: this.state.cli_phone.value,
    };
    this.props.memberRegistration(payload).then((response) => {
      if (response && response.success) {
        this.props.sendGTMEvents([{ event: 'becomeMember', languageCode: this.props.lang }]);
        this.props.setHasRegistered(true);
        this.props.login({ email: payload.email, password: payload.password }).then(() => {
          this.props.setShowRegistration(false);
          // eslint-disable-next-line no-console
          console.log({
            name: this.state.name.value,
            middle_name: this.state.middle_name.value,
            last_name: this.state.last_name.value,
            second_last_name: this.state.second_last_name.value,
          });
          const loggedUser = { ...this.props.loggedUser, second_last_name: this.state.second_last_name.value };
          this.props.setLoggedUser(loggedUser);
        });
      } else if (response && response.error_message === 'The email soft validator failed') {
        this.setState({
          loading: false,
          //registrationErrorMessage: response.error_message,
          registrationErrorMessage: this.context.t('Invalid email address. Please check and try again.'),
        });
      } else {
        this.setState({
          loading: false,
          registrationErrorMessage: this.context.t('A user with the provided email already exists'),
        });
      }
      // eslint-disable-next-line no-unused-vars
    }).catch((error) => {
      this.setState({
        loading: false,
        registrationErrorMessage: this.context.t('A user with the provided email already exists'),
      });
    });
  };

  onChangeValue = (fieldName, event) => {
    let value = event.target.type === 'checkbox'
      ? event.target.checked
      : event.target.value;

    // El email siempre en minúsculas (al teclear o pegar)
    if (fieldName === 'email' && typeof value === 'string') {
      value = value.toLowerCase();
    }

    // Para TODOS los campos, usa la misma estructura
    const updatedState = {
      value,
    };
    this.setState({ [fieldName]: { ...this.state[fieldName], ...updatedState } });
    if (fieldName === 'email') {
      this.setState({ resendError: '' });
      this.emailChecker.schedule(value);
    }
    /*if(fieldName=='cli_country'){
      this.setState({
        cli_phone: { ...this.state.cli_phone, value: `+${this.state[fieldName].dial_code}` },
      });
    }*/
  };

  togglePassword = () => {
    this.setState({
      passwordShown: !this.state.passwordShown,
    });
  }

  renderLoading() {
    if (!this.state.loading) {
      return null;
    }
    return (
      <div className={'loading'}>
        <img src={'/img/loading5.gif'}/>
        <p>{this.context.t('Wait a moment, please...')}</p>
      </div>
    );
  }

  termConditionsLinks = (ev) => {
    if (ev.preventDefault) {
      // Preventing default when opening the terms to avoid the input checkbox from being clicked
      ev.preventDefault();
    }
    let url = '';
    const { lang } = this.props;
    switch (lang) {
      case 'es':
        url = `${process.env.SANDOS_SITE}/es/terminos-y-condiciones-sandos4u`;
        break;
      case 'en':
        url = `${process.env.SANDOS_SITE}/terms-and-conditions-sandos4u`;
        break;
      case 'fr':
        url = `${process.env.SANDOS_SITE}/fr/terms-and-conditions-sandos4u`;
        break;
      default:
        url = `${process.env.SANDOS_SITE}/terms-and-conditions-sandos4u`;
    }
    window.open(url, '_blank');
  }

  privacyPolicyLinks = (ev) => {
    if (ev.preventDefault) {
      // Preventing default when opening the terms to avoid the input checkbox from being clicked
      ev.preventDefault();
    }
    let url = '';
    const { lang } = this.props;
    switch (lang) {
      case 'es':
        url = 'https://www.sandos.com/es/politica-de-privacidad';
        break;
      case 'en':
        url = 'https://www.sandos.com/privacy-policy';
        break;
      case 'fr':
        url = 'https://www.sandos.com/fr/privacy-policy';
        break;
      default:
        url = 'https://www.sandos.com/privacy-policy';
    }
    window.open(url, '_blank');
  }

  labelTerms = () => (
    <span className="acceptTerms whiteText">
      {this.context.t('I have read and accept the')}&nbsp;
      <span className='whiteText underlined' onClick={(ev) => this.termConditionsLinks(ev)}>
        {this.context.t('Terms & Conditions')}
      </span>
      &nbsp;{this.context.t('and the')}&nbsp;
      <span className='whiteText underlined' onClick={(ev) => this.privacyPolicyLinks(ev)}>
        {this.context.t('Privacy Policy')}
      </span>
    </span>
  );

  renderTermCheckbox() {
    return (
      <Checkbox
        id="loyalty_acceptTerms"
        label={this.labelTerms()}
        checked={this.state.book_conditions.value}
        errorMsg={this.state.book_conditions.msg}
        onChange={(ev) => this.onChangeValue('book_conditions', ev, true)}
        width={this.props.isMobile === true ? '50px' : '20px'}
        height={this.props.isMobile === true ? '50px' : '20px'}
        color='#FFFFFF'
      />
    );
  }

  optinTerms = () => (
    <span className="acceptTerms whiteText">
      {this.context.t('I agree to receive promotions from Sandos4U')}
    </span>
  );

  renderOptinCheckbox() {
    return (
      <Checkbox
        id="loyalty_optin"
        label={this.optinTerms()}
        checked={this.state.book_optin.value}
        errorMsg={this.state.book_optin.msg}
        onChange={(ev) => this.onChangeValue('book_optin', ev, true)}
        width={this.props.isMobile === true ? '50px' : '20px'}
        height={this.props.isMobile === true ? '50px' : '20px'}
        color='#FFFFFF'
      />
    );
  }

  renderUserRegistrationMessage() {
    if (this.props.new_member_discount_percentage_activated === false) {
      return (
        <h1 className='whiteText'>{this.context.t('As a {chain} member you can get discounts in exchange of coins and much more...', { chain: this.props.chainData.loyalty_name })}</h1>
      );
    }

    return (
        <Fragment>
          <h1 className='whiteText'>{this.context.t('REGISTER NOW TO GET THE BEST RATE GUARANTEED')}</h1>
        </Fragment>
    );
  }

  getNewMemberDiscountPercentage() {
    //Regresa loyalty.newMemberDiscountPercentage
    //Si es 0, regresa this.props.new_member_discount_percentage ya que eso es igual a chain.Data.new_member_discount_percentage
    if (this.props.new_member_discount_percentage != null) {
      if (this.props.new_member_discount_percentage > 0) {
        return this.props.new_member_discount_percentage;
      }

      return this.props.new_member_discount_percentage_chain;
    }
    return this.props.new_member_discount_percentage_chain;
  }

  onClickSignInNow = () => {
    this.props.setShowLogin(true);
    this.props.setShowRegistration(false);
  };

  // ACTIVE -> "Click to log in"
  onEmailStatusLogin = () => {
    this.onClickSignInNow();
  };

  // ACTIVE -> "Click to receive password reset instructions"
  // (abre forgot password con el email ya escrito)
  onEmailStatusForgotPassword = () => {
    setForgotPasswordPrefillEmail(this.state.email.value);
    this.props.setShowRecoverPassword(true);
    this.props.setShowRegistration(false);
  };

  // PENDING_VERIFICATION / UNSUBSCRIBED -> reenviar link de activación
  onResendActivationLink = () => {
    const email = this.state.email.value.trim();
    if (this.state.isResending || !canResendActivationLink(this.state.emailStatus) || !email) {
      return;
    }
    this.setState({ isResending: true, resendError: '' });
    this.props.resendActivationLink(email)
      .then(() => {
        this.setState({ isResending: false, showLinkSentModal: true });
      })
      .catch((error) => {
        this.setState({
          isResending: false,
          resendError: error && error.code === RESEND_ERROR_THROTTLED
            ? this.context.t('Please wait a moment before requesting another link.')
            : this.context.t('We could not send the link. Please try again.'),
        });
      });
  };

  // Tras reenviar el link el registro no puede continuar: cerramos el popup
  onCloseLinkSentModal = () => {
    this.setState({ showLinkSentModal: false });
    this.props.setShowRegistration(false);
  };

  renderEmailField() {
    const {
      email, emailStatus, emailCheckLoading, emailCheckFailed, isResending, resendError,
    } = this.state;
    const statusClass = getEmailInputStatusClass(EMAIL_FORM.REGISTER, emailStatus, emailCheckLoading, emailCheckFailed);
    const help = (
      <LoyaltyEmailStatusHelp
        id="loyalty_register_email_status"
        t={this.context.t}
        form={EMAIL_FORM.REGISTER}
        status={emailStatus}
        loading={emailCheckLoading}
        checkFailed={emailCheckFailed}
        isResending={isResending}
        resendError={resendError}
        onLogin={this.onEmailStatusLogin}
        onForgotPassword={this.onEmailStatusForgotPassword}
        onResend={this.onResendActivationLink}
        onDark
      />
    );
    // El help sólo se pinta cuando hay algo que mostrar; con eso ajustamos el margen del input
    const hasHelp = emailCheckLoading || emailCheckFailed || Boolean(emailStatus);

    return (
      <Fragment>
        <input
          type="email"
          placeholder={`${this.context.t('Email')}*`}
          value={email.value}
          onChange={(ev) => this.onChangeValue('email', ev)}
          className={['input-fieldRegister', statusClass, hasHelp ? 'loyaltyEmailInput--hasHelp' : '']
            .filter(Boolean).join(' ')}
          aria-describedby="loyalty_register_email_status"
          autoComplete="off"
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          required
        />
        {help}
      </Fragment>
    );
  }

  onChangeSelect(selectName, selectItem) {
    const isValid = selectItem.code !== ''; // these are required fields
    const statusUpdate = {
      value: selectItem,
      valid: isValid,
      msg: isValid
        ? ''
        : this.context.t('Please select your {fieldName}', {
          fieldName: this.label(selectName),
        }),
    };

    this.setState({
      [selectName]: { ...this.state[selectName], ...statusUpdate },
    });
  }

  onPhoneBlur(phoneNumber) {
    const fieldName = 'cli_phone';
    const event = {
      target: {
        type: 'text',
        value: phoneNumber,
      },
    };
    this.onChangeValue(fieldName, event, true);
  }

  renderPhoneSelector(disabled = false) {
    const { cli_phone, countries, cli_country } = this.state;
    if (countries.options.length === 0) {
      return null;
    }
    return (
      <div style={{ marginBottom: '12px' }}>
        <IntlTelInput
          onNumberBlur={(phoneNumber) => this.onPhoneBlur(phoneNumber)}
          validationError={cli_phone.msg}
          currentCountry={cli_country.value.iso_code}
          countriesData={countries.options}
          label={this.context.t('Telephone')}
          placeholder={`${this.context.t('Telephone')}*`}
          showLabel={false} // Esto oculta el label
          lang={countries.lang}
          valid={cli_phone.valid}
          number={cli_phone.value}
          required={true}
          disabled={disabled}
        />
      </div>
    );
  }

  render() {
    const message2 = this.context.t('Register now and use a {coins} coins gift to apply to your booking',
      { coins: this.props.coinsForRegistering });

    return (
      <div className={'loyaltyRegistration'}>
        <div className={'backdrop'} onClick={() => this.props.setShowRegistration(false)} />
        <div className={'content content2'}>
          <div className="signup-container">
            <div className="loyaltyCenterImage">
              <img
                src={sandos4uWhite}
                alt="Sandos4U"
              />
            </div>
            <div className='registerNowTitle'>
              <h3>{this.renderUserRegistrationMessage()}</h3>
            </div>
            {this.renderLoading()}
            <CloseIcon onClick={() => this.props.setShowRegistration(false)}/>
            <p>{this.props.new_member_discount_percentage_activated === false && message2}</p>
            {/* autoComplete off + new-password: es un alta, el navegador no debe rellenar credenciales guardadas */}
            <form onSubmit={this.register} className="signup-form" autoComplete="off">
              {this.state.registrationErrorMessage && (
                <div className="formErrorMessage">
                  {this.state.registrationErrorMessage}
                </div>
              )}
              <div className="input-group">
                <div className="w-full md:w-1/2">
                  <input
                    type="text"
                    placeholder={`${this.context.t('Name')}*`}
                    inputData={this.state.name}
                    onChange={(ev) => this.onChangeValue('name', ev)} // Pass 'username' and event
                    className="input-fieldRegister"
                    autoComplete="off"
                    required
                  />
                </div>
                <div className="w-full md:w-1/2">
                  <input
                    type="text"
                    placeholder={`${this.context.t('Last name')}*`}
                    inputData={this.state.last_name}
                    onChange={(ev) => this.onChangeValue('last_name', ev)} // Pass 'username' and event
                    className="input-fieldRegister"
                    autoComplete="off"
                    required
                  />
                </div>
              </div>
              <div className="input-group">
                <div className="w-full md:w-1/2">
                  <div className="country-dropdown-isolated">
                    <FormControl
                      inputData={this.state.cli_country}
                      onChange={this.onChangeValue}
                    >
                      <DsDropdownList
                        className={`input-fieldRegister ${this.state.cli_country.value === ''
                          ? 'selectedCountry' : 'notSelectedCountry'}`}
                        initialId={[]}
                        items={this.state.countries.options}
                        searchText={this.state.cli_country.value.name}
                        onChange={(name, ev) => this.onChangeSelect(name, ev)}
                        withSearch
                        placeholder={`${this.context.t('Country')}*`}
                      />
                    </FormControl>
                  </div>
                </div>
                <div className="w-full md:w-1/2">
                  <input
                    type="date"
                    value={this.state.date_of_birth.value} // Accede a .value
                    onChange={(ev) => this.onChangeValue('date_of_birth', ev)}
                    required
                    onFocus={(e) => e.target.showPicker?.()}
                    max={new Date().toISOString().split('T')[0]}
                    className={`input-fieldRegister ${!this.state.date_of_birth.value ? 'empty-date' : ''}`} // Verifica .value
                    data-placeholder={`${this.context.t('Date of birth')}*`} // ← Agrega este atributo
                  />
                </div>
              </div>
              <div className="input-group">
                <div className="w-full md:w-1/2">
                  {this.renderEmailField()}
                </div>
                <div className="w-full md:w-1/2">
                  {this.renderPhoneSelector(false)}
                </div>

              </div>
              <div className="input-group">
                <div className="w-full md:w-1/2">
                  <input
                    type="password"
                    placeholder={`${this.context.t('Password')}*`}
                    inputData={this.state.password}
                    onChange={(ev) => this.onChangeValue('password', ev)} // Pass 'password' and event
                    className="input-fieldRegister input-fieldRegister--hasHint"
                    aria-describedby="register_password_hint"
                    autoComplete="new-password"
                    required
                  />
                  <p id="register_password_hint" className="passwordHint">
                    {this.context.t('(Use minimum 8 characters. The characters #, ?, % are not allowed)')}
                  </p>
                </div>
                <div className="w-full md:w-1/2">
                  <input
                    type="password"
                    placeholder={`${this.context.t('Confirm password')}*`}
                    inputData={this.state.password2}
                    onChange={(ev) => this.onChangeValue('password2', ev)} // Pass 'password' and event
                    className="input-fieldRegister"
                    autoComplete="new-password"
                    required
                  />
                </div>
              </div>
              {this.renderOptinCheckbox()}
              {this.renderTermCheckbox()}
              <div className="flex mt-2 justify-between">
                    {this.state.registrationErrorMessage && <a
                      onClick={() => {
                        this.props.setShowLogin(true);
                        this.props.setShowRegistration(false);
                      }} className="m-5">{this.context.t('Login')}</a>}
              </div>
              <div className="becomeAMemberCentered">
                <button
                  type="submit"
                  className="submit-btn"
                  disabled={isSubmitBlockedByEmailStatus(EMAIL_FORM.REGISTER, this.state.emailStatus)}
                >
                  {this.context.t('Become a member')}
                </button>
              </div>
            </form>
            <div className='alignedLeft'>
              <span className="acceptTerms whiteText">
                {this.context.t('Have an account?')}&nbsp;
                <span className='whiteText underlined' onClick={() => this.onClickSignInNow()}>
                  {this.context.t('Sign in now')}
                </span>
                {this.props.isMobile === true && <div className='spaceForMobileUserRegistration'></div>}
              </span>
            </div>
          </div>
        </div>
        {this.state.showLinkSentModal && (
          <LoyaltyActivationLinkSentModal t={this.context.t} onClose={this.onCloseLinkSentModal} />
        )}
      </div>
    );
  }
}

UserRegistration.contextTypes = {
  t: PropTypes.func.isRequired,
};

UserRegistration.propTypes = {
  chainData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  lang: state.i18nState.lang,
  coinsForRegistering: state.loyalty.coinsForRegistering,
  loggedUser: state.loyalty.loggedUser,
  isMobile: state.booking.device === DEVICES.MOBILE,
  new_member: state.loyalty.newMember,
  new_member_discount_percentage: state.loyalty.newMemberDiscountPercentage,
  new_member_discount_percentage_chain: state.booking.hotel !== null
    ? state.session.chainData.loyalty_levels
      .find((member) => (member.membership_name === (state.bookingFormState.agentCode !== '' ? 'Blue Agent' : 'Blue')))
      .new_member_discount_percentage_hotels[state.booking.hotel.code.toLowerCase()]
    : 0,
  new_member_discount_percentage_activated: state.booking.hotel != null
    ? (state.booking.hotel.new_member_discount_percentage_activated === true
      && state.bookingFormState.agentSell === 'false') : false,
});

const mapDispatchToProps = (dispatch) => ({
  memberRegistration: (payload) => dispatch(memberRegistration(payload)),
  sendGTMEvents: (payload) => dispatch(sendGTMEvents(payload)),
  login: (payload) => dispatch(login(payload)),
  setShowRegistration: (payload) => dispatch(setShowRegistration(payload)),
  setHasRegistered: (payload) => dispatch(setHasRegistered(payload)),
  setLoggedUser: (payload) => dispatch(setLoggedUser(payload)),
  setShowLogin: (payload) => dispatch(setShowLogin(payload)),
  setShowRecoverPassword: (payload) => dispatch(setShowRecoverPassword(payload)),
  checkRegistrationEmail: (email) => dispatch(checkRegistrationEmail(email)),
  resendActivationLink: (email) => dispatch(resendActivationLink(email)),
  getCountries: (payload) => dispatch(getCountries(payload)),
  setClientIpCountryCode: (ip_country_code) => dispatch(setClientIpCountryCode(ip_country_code)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserRegistration);
